import lodash from 'lodash';
import store from './store';

export default function hasPermissions(permissionCode) {
  if (store.state.currentUser) {
    return lodash.intersection(permissionCode, store.state.currentUser.permissions).length !== 0;
  }
  return false;
}
